import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { defaultPostBakingWasteWoodInputDetail } from "../../constance/dataTypes";
import { GET, PATCH, POST, PUT } from "../../utils/HttpClient";
import { URL_POST_BAKING } from "../../constance/urls";
import ErrorMessage from "../common/ErrorMessage";
import * as _ from "lodash";
import { Toast } from "../../utils/Toast";
import InputWasteWoodForm from "./InputWasteWoodForm";
import Title from "antd/es/typography/Title";
import { DATE_FORMAT, HUMAN_DATE_FORMAT } from "../../constance/strings";
import dayjs from "dayjs";
import { Spin, Button, Space, Form } from "antd";
import ColorButton from "../common/ColorButton";
import { EditFilled, PlusOutlined } from "@ant-design/icons";
import { BLUE_COLOR, GREEN, PRIMARY_COLOR } from "../../constance/color";


export default function InputWasteWood(props) {
  const {
    target,
    transactionDetail,
    groupDate,
    inputDate,
    onBack,
  } = props;

  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState(false);
  const [errorMessages, setErrorMessages] = React.useState(null);
  const isCreate = !target ? true : false;
  const transactionHasNoPostBakingGroup = !_.get(transactionDetail, 'post_baking_group_date', null);

  const handleSubmit = async (values) => {
    setLoading(true);
    setErrorMessages(null)
    try {
      const validate = await form.validateFields();
      if (isCreate) {
        await POST(URL_POST_BAKING.POST_BAKING_WASTE_WOOD_INPUT, values)
      } else {
        await PUT(`${URL_POST_BAKING.POST_BAKING_WASTE_WOOD_INPUT}${target}/`, values)
      }
      if (transactionHasNoPostBakingGroup) {
        await PATCH(`${URL_POST_BAKING.POST_BAKING_WASTE_WOOD_INPUT_TRANSACTION}${transactionDetail.id}/`,
          { post_baking_group_date: groupDate, input_date: inputDate }
        )
      }
      Toast.success(`${t('save')} ${t('success')}`)
      onBack();
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    }
  }

  const fetchData = async () => {
    setLoading(true);
    setErrorMessages(null)
    try {
      const response = await GET(`${URL_POST_BAKING.POST_BAKING_WASTE_WOOD_INPUT}${target}/`)
      form.setFieldsValue(response.data)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => {
    if (target) {
      fetchData()
    } else {
      form.setFieldValue('transaction', transactionDetail.id)
    }
  }, [target])

  return (
    <div style={{ marginTop: '1rem' }}>
      <Title level={5}>
        <div>
          {t('post_baking_waste_wood_count.group_date')}&nbsp;
          {dayjs(groupDate, DATE_FORMAT).format(HUMAN_DATE_FORMAT)}
        </div>
      </Title>
      <Spin spinning={loading} tip={t('loading')} fullscreen />
      <ErrorMessage message={errorMessages} />

      <InputWasteWoodForm form={form} />
      <Space>
        <ColorButton
          type='primary'
          override={isCreate ? GREEN : BLUE_COLOR}
          icon={isCreate ? <PlusOutlined /> : <EditFilled />}
          onClick={() => handleSubmit(form.getFieldsValue())} >
          {isCreate ? t('add') : t('save')}</ColorButton>
        <Button variant="filled" color="default" onClick={onBack} >{t('cancel')}</Button>
      </Space>
    </div>
  )
}


InputWasteWood.propTypes = {
  target: PropTypes.string,
  transactionDetail: PropTypes.objectOf(defaultPostBakingWasteWoodInputDetail),
  groupDate: PropTypes.string,
  onBack: PropTypes.func,
}

InputWasteWood.defaultProps = {
  target: null,
  transaction: defaultPostBakingWasteWoodInputDetail,
  groupDate: '',
  onBack: () => null,
}